import React from 'react';

import { TableCell } from '@material-ui/core';
import { CustomRow, GenericObject } from 'interfaces/utils';

export const createTableCellValues = (
  customRows: CustomRow[],
  genericObject: GenericObject,
): JSX.Element[] =>
  customRows.map(({ field, getParsedValue, options }, index) => (
    <TableCell
      key={index}
      align={options?.align || index > 0 ? 'right' : 'left'}
    >
      {getParsedValue
        ? getParsedValue(
            typeof genericObject[field] === 'number'
              ? Number(genericObject[field])
              : String(genericObject[field]),
          )
        : genericObject[field]}
    </TableCell>
  ));
